import React, { Fragment } from "react";
import { Select } from 'antd';

export default function SelectGroup(props) {
  const {
    numSelects,
    onChange,
    value,
  } = props;
  const selectOptions = [];
  const defaultValue = value || 1;
  for (let i = 1; i <= numSelects; i++) selectOptions.push(i)

  return (
    <Select onChange={onChange} defaultValue={defaultValue}
            style={{ width: 80 }}
    >
      {selectOptions.map((option, index) => {
        return (
          <Select.Option value={option} key={index}>
            {option}
          </Select.Option>
        )
      })}
    </Select>
  )
}